import { CreateAndUpdateTaskTypeDTO2, TaskTypeCategoryDTO } from '../../../api/api';
import { userAllowedThroughFeatureFlag } from '../../../utils/validation/userAllowedFeatureFlag';

export const isMeterTaskType = (
  taskTypeCategoryIds?: number[],
  specificAssetType?: string,
  taskTypeCategories?: TaskTypeCategoryDTO[]
) => {
  const viaIntegrationId = taskTypeCategories?.find((tasktype) => tasktype.name === 'Via. integration')?.id;
  if (viaIntegrationId !== undefined) {
    return specificAssetType === 'Måler' && taskTypeCategoryIds?.includes(viaIntegrationId);
  }
  return false;
};

// With the flag on, a preparation task type can't be saved without a main task type and a day window.
export const isStrictPreparationValidation = () =>
  userAllowedThroughFeatureFlag(window._env_.FeatureFlags_StrictPreparationValidation);

const isWholeDays = (value?: number | null) => value != null && Number.isInteger(value) && value >= 0;

export interface PreparationFieldErrors {
  mainTaskId: boolean;
  minTimeBeforeMainTaskDays: boolean;
  maxTimeBeforeMainTaskDays: boolean;
}

// A day window is required with strict validation or a main task type; a started window must be complete and min <= max.
export const getPreparationFieldErrors = ({
  mainTaskId,
  minTimeBeforeMainTaskDays: minDays,
  maxTimeBeforeMainTaskDays: maxDays
}: CreateAndUpdateTaskTypeDTO2): PreparationFieldErrors => {
  const isStrict = isStrictPreparationValidation();
  const mainTaskIdError = isStrict && !mainTaskId;

  const isDayWindowRequired = isStrict || !!mainTaskId || minDays != null || maxDays != null;
  if (!isDayWindowRequired)
    return { mainTaskId: mainTaskIdError, minTimeBeforeMainTaskDays: false, maxTimeBeforeMainTaskDays: false };

  const minIsGreaterThanMax = isWholeDays(minDays) && isWholeDays(maxDays) && (minDays as number) > (maxDays as number);

  return {
    mainTaskId: mainTaskIdError,
    minTimeBeforeMainTaskDays: !isWholeDays(minDays) || minIsGreaterThanMax,
    maxTimeBeforeMainTaskDays: !isWholeDays(maxDays) || minIsGreaterThanMax
  };
};
